import { render, staticRenderFns } from "./ChartingWorkspaceSearchDialog.vue?vue&type=template&id=6835546a&scoped=true&"
import script from "./ChartingWorkspaceSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceSearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceSearchDialog.vue?vue&type=style&index=0&id=6835546a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835546a",
  null
  
)

export default component.exports